import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { FormTypeEnum } from '@/types';

type TRecorderControllersReturn = {
  recorderDialog: ReturnType<typeof useDisclosureWithData>;
  recorderDrawer: ReturnType<typeof useDisclosureWithData<{ type: FormTypeEnum; data: any }>>;
  handleDeleteRecorder: () => void;
};

export function useRecorderControllers(): TRecorderControllersReturn {
  const recorderDialog = useDisclosureWithData<any>();
  const recorderDrawer = useDisclosureWithData<{ type: FormTypeEnum; data: any }>();

  const handleDeleteRecorder = () => {
    console.info('Delete', recorderDialog.data);
  };

  return {
    recorderDialog,
    recorderDrawer,
    handleDeleteRecorder,
  };
}
